module.exports = __webpack_public_path__ + "static/img/class_task_stu_remove.c5309f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class_task_stu_remove.png
// module id = dWMa
// module chunks = 2